import api from 'api'

type EditBillRateRequest = {
  billRateId: number
  payRate: number
  billRate: number
}

export const editBillRate = async (
  request: EditBillRateRequest
): Promise<void> => {
  await api.patch(`/admin/bill_rate/${request.billRateId}`, {
    pay_rate: request.payRate,
    bill_rate: request.billRate,
  })
}
